"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
/** @jsxImportSource @emotion/react */
const react_1 = require("@emotion/react");
const fa_1 = require("react-icons/fa");
const styles = (0, react_1.css) `
  border-radius: 50%;
  width: 16px;
  height: 16px;
  background-color: transparent;
  border: none;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;

  .icon {
    color: #252525;
    width: 8px;
  }

  :hover {
    background-color: red;
    border-radius: 50%;

    .icon {
      color: white;
    }
  }
`;
function DeleteButton({ onDelete, className = 'delete', style = {}, }) {
    return ((0, jsx_runtime_1.jsx)("button", { css: styles, className: className, style: style, type: "button", onClick: onDelete, children: (0, jsx_runtime_1.jsx)(fa_1.FaTimes, { className: "icon" }) }));
}
exports.default = DeleteButton;
